import { Direction } from '@angular/cdk/bidi';
import { NumberInput, BooleanInput } from '@angular/cdk/coercion';
import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import {
  DECREASE,
  INCREASE,
} from 'src/app/modules/route-planner/constants/multi-language.constants';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Component({
    selector: 'mot-slider',
    templateUrl: './mot-slider.component.html',
    styleUrls: ['./mot-slider.component.scss'],
    standalone: false
})
export class MotSliderComponent implements ControlValueAccessor, OnInit {
  @Input() value: string;
  @Input() class: string;
  @Input() inputClass: string;
  @Input() max: number;
  @Input() min: number = 0;
  @Input() step: number = 1;
  @Input() showTicks: boolean = false;
  @Input() thumbLabel: boolean = true;
  @Input() direction: Direction = 'rtl';
  /**
   * Accessible label describing what the slider controls (e.g. "Maximum route time").
   * Used to compose aria-labels for the +/− buttons so SR users know which slider
   * they are operating ("Increase {label}" / "Decrease {label}").
   */
  @Input() label: string = '';

  formControl: FormControl;

  /** Translated "Increase" verb used for the plus button aria-label. */
  private increaseText: string = INCREASE.hebrew;
  /** Translated "Decrease" verb used for the minus button aria-label. */
  private decreaseText: string = DECREASE.hebrew;

  /** Composed aria-label for the plus button: "Increase {label}" (label may be empty). */
  get increaseAriaLabel(): string {
    return this.label ? `${this.increaseText} ${this.label}` : this.increaseText;
  }

  /** Composed aria-label for the minus button: "Decrease {label}" (label may be empty). */
  get decreaseAriaLabel(): string {
    return this.label ? `${this.decreaseText} ${this.label}` : this.decreaseText;
  }

  constructor(@Optional() @Self() public ngControl: NgControl, private readonly languageService: LanguageService) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      this.formControl = this.ngControl.control as FormControl;
      if (this.value) {
        this.formControl.setValue(this.value);
      }
    }
    this.initializeMultiLanguageTexts()
  }

  initializeMultiLanguageTexts() {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction;
      this.increaseText = INCREASE[language.language];
      this.decreaseText = DECREASE[language.language];
    })
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (!!this.formControl) {
      if (isDisabled) this.formControl.disable();
      else this.formControl.enable();
    }
  }

  increaseValue() {
    const newValue = this.formControl.value + this.step;

    this.formControl.setValue(newValue > this.max ? this.max : newValue)
  }


  decreaseValue() {
    const newValue = this.formControl.value - this.step;

    this.formControl.setValue(newValue < this.min ? this.min : newValue)
  }
}
